/* =========================================================
   TUNNEL GUSTAVE — machine à états, 100% locale.
   Aucun appel réseau entre les étapes.
   ========================================================= */
(function () {
  'use strict';

  var racine = document.querySelector('[data-tunnel]');
  if (!racine) return;

  var balise = racine.querySelector('[data-tunnel-donnees]');
  var DATA;
  try { DATA = JSON.parse(balise.textContent); } catch (e) { return; }
  if (!DATA || !Object.keys(DATA).length) return;

  /* ---------- Constantes ---------- */
  var SANS_CADRE = 'Sans cadre';
  var LIMITEES = ['Vert Sauge', 'Lin Blanchi', 'Herbe de Pampa'];

  var NUANCES = {
    'Blanc Coton': 'sw-blanc',
    'Rose Poudré': 'sw-rose',
    'Charcoal': 'sw-anthracite',
    'Vert Sauge': 'sw-sauge',
    'Lin Blanchi': 'sw-lin',
    'Herbe de Pampa': 'sw-pampa'
  };

  /* Codes courts utilisés par la matrice d'aperçus */
  var CODE_FOND = {
    'Blanc Coton': 'blanc',
    'Rose Poudré': 'rose',
    'Charcoal': 'anthracite',
    'Vert Sauge': 'sauge',
    'Lin Blanchi': 'lin',
    'Herbe de Pampa': 'pampa'
  };
  var CODE_CADRE = {
    'Cadre noir': 'noir',
    'Cadre blanc': 'blanc',
    'Cadre noyer': 'noyer',
    'Cadre chêne clair': 'bouleau'
  };

  function lireJson(selecteur) {
    var el = racine.querySelector(selecteur);
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }
  var APERCUS = lireJson('[data-apercus]');
  var NUANCIERS = lireJson('[data-nuanciers]');

  var BOIS = {
    'Cadre noir': '#211E1B',
    'Cadre blanc': '#F2F0EC',
    'Cadre noyer': 'linear-gradient(150deg,#7C5231,#4F3320)',
    'Cadre chêne clair': 'linear-gradient(150deg,#E4CBA3,#C6A273)'
  };

  /* Combinaison mise en avant par défaut, selon le nombre d'animaux.
     Elle ne s'applique que tant que le visiteur n'a pas choisi lui-même
     un fond : hors de question d'écraser sa sélection. */
  var DEFAUTS = {
    1: { fond: 'Herbe de Pampa', cadre: 'Cadre noyer' },
    2: { fond: 'Lin Blanchi', cadre: 'Cadre noyer' },
    3: { fond: 'Lin Blanchi', cadre: 'Cadre noyer' },
    4: { fond: 'Lin Blanchi', cadre: 'Cadre noyer' }
  };

  function appliquerDefaut(n) {
    var d = DEFAUTS[n];
    if (!d) return;
    if (fonds().indexOf(d.fond) !== -1) etat.fond = d.fond;
    if (cadres().indexOf(d.cadre) !== -1) { etat.cadre = d.cadre; etat.encadre = true; }
  }

  var SEUIL = parseInt(racine.dataset.seuil || '69', 10) * 100;
  var PORT = racine.dataset.port || '4,90 €';
  var APERCU_ID = racine.dataset.apercu || null;
  var MUG_ID = racine.dataset.mug || null;
  var APERCU_PRIX = parseInt(racine.dataset.apercuPrix || '0', 10);

  /* ---------- Raccourcis ---------- */
  function q(s, p) { return (p || racine).querySelector(s); }
  function qa(s, p) { return Array.prototype.slice.call((p || racine).querySelectorAll(s)); }

  function euros(centimes) {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency', currency: 'EUR',
      minimumFractionDigits: centimes % 100 === 0 ? 0 : 2,
      maximumFractionDigits: centimes % 100 === 0 ? 0 : 2
    }).format(centimes / 100);
  }

  /* ---------- État ---------- */
  var etat = {
    nb: 1,
    fond: null,
    format: null,
    cadre: 'Cadre noir',
    encadre: true,
    etape: 1,
    max: 1,
    noms: [],
    photos: [],
    apercu: false,
    fondChoisi: false,
    photoPlusTard: false
  };

  /* ---------- Accès aux variantes ---------- */
  function produit() { return DATA[String(etat.nb)]; }

  function variantes() { return produit() ? produit().v : []; }

  function uniques(index) {
    var vus = [], out = [];
    variantes().forEach(function (v) {
      if (vus.indexOf(v[index]) === -1) { vus.push(v[index]); out.push(v[index]); }
    });
    return out;
  }

  function fonds() { return uniques(1); }
  function formats() { return uniques(2); }
  function cadres() { return uniques(3); }

  function trouver(fond, format, cadre) {
    var liste = variantes();
    for (var i = 0; i < liste.length; i++) {
      if (liste[i][1] === fond && liste[i][2] === format && liste[i][3] === cadre) return liste[i];
    }
    return null;
  }

  function cadreDispo(fond, format, cadre) { return !!trouver(fond, format, cadre); }

  /* Ramène l'état vers une combinaison qui existe vraiment. */
  function recaler() {
    var lf = fonds();
    if (lf.indexOf(etat.fond) === -1) etat.fond = lf[0];

    var lfo = formats();
    if (lfo.indexOf(etat.format) === -1) etat.format = lfo[0];

    if (!etat.encadre) {
      if (cadreDispo(etat.fond, etat.format, SANS_CADRE)) {
        etat.cadre = SANS_CADRE;
      } else {
        etat.encadre = true;
        etat.cadre = 'Cadre noir';
      }
    }
    if (etat.encadre && (etat.cadre === SANS_CADRE || !cadreDispo(etat.fond, etat.format, etat.cadre))) {
      var lc = cadres().filter(function (c) { return c !== SANS_CADRE && cadreDispo(etat.fond, etat.format, c); });
      etat.cadre = lc[0] || cadres()[0];
    }

    /* Le nombre de champs suit le nombre d'animaux */
    etat.noms.length = etat.nb;
    etat.photos.length = etat.nb;
  }

  function variante() { return trouver(etat.fond, etat.format, etat.cadre); }

  /* =========================================================
     RENDU
     ========================================================= */

  /* --- Étape 1 : le nombre d'animaux ---
     Ces vignettes viennent de Liquid et ne sont pas regénérées,
     il faut donc synchroniser leur état sélectionné à la main. */
  function rendreNb() {
    qa('[data-opt="nb"]').forEach(function (el) {
      var choisi = el.dataset.valeur === String(etat.nb);
      el.dataset.selected = choisi ? 'true' : 'false';
      var input = q('input', el);
      if (input) input.checked = choisi;
    });
  }

  /* --- Étape 2 : les fonds --- */
  function rendreFonds() {
    var hote = q('[data-fonds]');
    hote.innerHTML = '';
    var base = null;

    fonds().forEach(function (f) {
      var v = trouver(f, etat.format, etat.cadre) || variantes().filter(function (x) { return x[1] === f; })[0];
      if (base === null && v) base = v[4];

      var label = document.createElement('label');
      label.className = 'opt';
      label.dataset.opt = 'fond';
      label.dataset.valeur = f;
      if (f === etat.fond) label.dataset.selected = 'true';

      var supp = (v && base !== null && v[4] > base) ? v[4] - base : 0;
      var limitee = LIMITEES.indexOf(f) !== -1;

      var nuancier = NUANCIERS[f]
        ? ' style="background-image:url(' + NUANCIERS[f] + ');background-size:cover;background-position:center"'
        : '';

      label.innerHTML =
        '<input type="radio" name="choix-fond" value="' + f + '"' + (f === etat.fond ? ' checked' : '') + '>' +
        (limitee ? '<span class="opt__tag">Édition limitée</span>' : '') +
        '<span class="opt__swatch ' + (NUANCES[f] || '') + '"' + nuancier + '></span>' +
        '<span class="opt__label">' + f + '</span>' +
        (supp > 0 ? '<span class="opt__price">+ ' + euros(supp) + '</span>' : '');

      hote.appendChild(label);
    });
  }

  /* --- Étape 3 : formats et cadres --- */
  function rendreFormats() {
    var hote = q('[data-formats]');
    hote.innerHTML = '';
    hote.className = 'choix choix--' + Math.min(formats().length, 3);

    formats().forEach(function (fo) {
      var v = trouver(etat.fond, fo, etat.cadre) || variantes().filter(function (x) { return x[2] === fo; })[0];
      var label = document.createElement('label');
      label.className = 'opt';
      label.dataset.opt = 'format';
      label.dataset.valeur = fo;
      if (fo === etat.format) label.dataset.selected = 'true';

      var cm = fo.replace(/\s*cm\s*$/i, '').trim();
      var parts = cm.split(/\s*x\s*/i);
      var ratio = parts.length === 2 ? (parseFloat(parts[0]) / parseFloat(parts[1])) : 1;
      var largeur = ratio >= 1 ? 62 : Math.round(62 * ratio);
      var hauteur = ratio >= 1 ? Math.round(62 / ratio) : 62;

      label.innerHTML =
        '<input type="radio" name="choix-format" value="' + fo + '"' + (fo === etat.format ? ' checked' : '') + '>' +
        '<span style="display:grid;place-items:center;height:72px">' +
          '<span style="display:block;width:' + largeur + 'px;height:' + hauteur + 'px;border:2.5px solid var(--ink);border-radius:2px;background:var(--paper-deep)"></span>' +
        '</span>' +
        '<span class="opt__label">' + fo + '</span>' +
        (v ? '<span class="opt__price">' + euros(v[4]) + '</span>' : '');

      hote.appendChild(label);
    });
  }

  function rendreCadres() {
    var hote = q('[data-cadres]');
    var note = q('[data-note-sanscadre]');
    hote.innerHTML = '';

    /* Filet de sécurité : si une combinaison sans cadre venait à disparaître
       du catalogue, on désactive le bouton plutôt que de laisser passer
       une commande impossible. */
    var posterDispo = cadreDispo(etat.fond, etat.format, SANS_CADRE);
    var segSans = q('[data-segment="sans"]');
    if (segSans) {
      segSans.dataset.disabled = posterDispo ? 'false' : 'true';
      var radioSans = q('input', segSans);
      if (radioSans) radioSans.disabled = !posterDispo;
    }

    if (!etat.encadre) {
      hote.hidden = true;
      note.hidden = false;
      qa('[data-segment]').forEach(function (s) {
        s.dataset.selected = (s.dataset.segment === 'sans') ? 'true' : 'false';
      });
      return;
    }
    hote.hidden = false;
    note.hidden = true;

    var base = null;
    cadres().filter(function (c) { return c !== SANS_CADRE; }).forEach(function (c) {
      var v = trouver(etat.fond, etat.format, c);
      if (!v) return;
      if (base === null) base = v[4];

      var label = document.createElement('label');
      label.className = 'opt';
      label.dataset.opt = 'cadre';
      label.dataset.valeur = c;
      if (c === etat.cadre) label.dataset.selected = 'true';

      var supp = v[4] - base;
      var court = c.replace(/^Cadre\s+/i, '');
      court = court.charAt(0).toUpperCase() + court.slice(1);

      label.innerHTML =
        '<input type="radio" name="choix-cadre" value="' + c + '"' + (c === etat.cadre ? ' checked' : '') + '>' +
        '<span class="opt__swatch" style="background:' + (BOIS[c] || '#ccc') + '"></span>' +
        '<span class="opt__label">' + court + '</span>' +
        (supp > 0 ? '<span class="opt__price">+ ' + euros(supp) + '</span>' : '');

      hote.appendChild(label);
    });

    qa('[data-segment]').forEach(function (s) {
      s.dataset.selected = ((s.dataset.segment === 'cadre') === etat.encadre) ? 'true' : 'false';
    });
  }

  /* --- Étape 4 : prénoms et photos --- */
  function rendreAnimaux() {
    var hote = q('[data-animaux]');
    var existants = qa('[data-animal]', hote).length;
    if (existants === etat.nb) return;

    hote.innerHTML = '';
    for (var i = 0; i < etat.nb; i++) {
      var n = i + 1;
      var suffixe = etat.nb > 1 ? ' ' + n : '';
      var bloc = document.createElement('div');
      bloc.className = 'animal';
      bloc.dataset.animal = String(n);
      bloc.innerHTML =
        (etat.nb > 1 ? '<p class="animal__head"><span>' + n + '</span> Animal ' + n + '</p>' : '') +
        '<div class="champ">' +
          '<label for="nom-' + n + '">Son prénom, tel qu\'il sera écrit sur le tableau</label>' +
          '<input type="text" id="nom-' + n + '" maxlength="18" autocomplete="off" ' +
            'name="properties[Prénom' + suffixe + ']" data-nom="' + i + '" placeholder="Gustave">' +
        '</div>' +
        '<div class="depot" data-depot="' + i + '">' +
          '<input type="file" accept="image/*" name="properties[Photo' + suffixe + ']" data-photo="' + i + '" ' +
            'aria-label="Photo de l\'animal ' + n + '">' +
          '<span class="depot__zone">' +
            '<span class="depot__icone" data-depot-icone></span>' +
            '<span class="depot__txt">' +
              '<b data-depot-nom>Ajouter sa photo</b>' +
              '<small>Glissez le fichier ici ou cliquez pour choisir</small>' +
            '</span>' +
          '</span>' +
        '</div>';
      hote.appendChild(bloc);
    }

    /* Icônes + restauration des valeurs déjà saisies */
    qa('[data-depot-icone]', hote).forEach(function (el) {
      el.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 15.5V3.5"/><path d="m8 7.2 4-3.7 4 3.7"/><path d="M4 14.5v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4"/></svg>';
    });
    qa('[data-nom]', hote).forEach(function (input) {
      var i = parseInt(input.dataset.nom, 10);
      if (etat.noms[i]) input.value = etat.noms[i];
    });
  }

  /* --- Photo maintenant ou plus tard ---
     Beaucoup de visiteurs commandent sans avoir la photo sous la main.
     Leur imposer le téléversement immédiat fait perdre la vente. */
  function majModePhoto() {
    qa('[data-photo-mode]').forEach(function (s) {
      s.dataset.selected = ((s.dataset.photoMode === 'plus-tard') === etat.photoPlusTard) ? 'true' : 'false';
      var input = q('input', s);
      if (input) input.checked = (s.dataset.photoMode === 'plus-tard') === etat.photoPlusTard;
    });

    var hote = q('[data-animaux]');
    if (hote) hote.classList.toggle('sans-photo', etat.photoPlusTard);

    /* Un champ désactivé n'est pas envoyé avec le formulaire. */
    qa('[data-photo]').forEach(function (i) { i.disabled = etat.photoPlusTard; });

    var note = q('[data-note-photo]');
    var notePlusTard = q('[data-note-plus-tard]');
    var prop = q('[data-prop-plustard]');
    if (note) note.hidden = etat.photoPlusTard;
    if (notePlusTard) notePlusTard.hidden = !etat.photoPlusTard;
    if (prop) prop.disabled = !etat.photoPlusTard;
  }

  /* --- Prix, récap, résumés --- */
  function rendrePrix() {
    var v = variante();
    if (!v) return;

    var prix = v[4] + (etat.apercu ? APERCU_PRIX : 0);
    var barre = v[5] > v[4] ? v[5] + (etat.apercu ? APERCU_PRIX : 0) : 0;

    q('[data-prix]').textContent = euros(prix);
    q('[data-prix-barre]').textContent = barre ? euros(barre) : '';

    var eco = q('[data-prix-eco]');
    if (barre) {
      eco.hidden = false;
      eco.textContent = '− ' + Math.round((1 - prix / barre) * 100) + ' %';
    } else { eco.hidden = true; }

    /* Total rappelé sous chaque étape */
    qa('[data-prix-mini]').forEach(function (el) { el.textContent = euros(prix); });
    qa('[data-prix-mini-barre]').forEach(function (el) { el.textContent = barre ? euros(barre) : ''; });
    qa('[data-prix-mini-eco]').forEach(function (el) {
      if (barre) { el.hidden = false; el.textContent = '− ' + Math.round((1 - prix / barre) * 100) + ' %'; }
      else { el.hidden = true; }
    });

    /* Livraison offerte */
    var reste = SEUIL - prix;
    var txt = q('[data-livraison-txt]');
    var jauge = q('[data-livraison-jauge]');
    if (reste > 0) {
      txt.innerHTML = 'Plus que <b>' + euros(reste) + '</b> pour la livraison offerte, sinon ' + PORT;
      jauge.style.width = Math.min(100, (prix / SEUIL) * 100) + '%';
    } else {
      txt.innerHTML = '<b>Livraison offerte</b>, c\'est cadeau';
      jauge.style.width = '100%';
    }

    /* Champ variante */
    q('[data-variant-id]').value = v[0];
    q('[data-prop-nb]').value = String(etat.nb);
  }

  function rendreRecap() {
    q('[data-recap-nb]').textContent = etat.nb + (etat.nb > 1 ? ' animaux' : ' animal');
    q('[data-recap-fond]').textContent = etat.fond;
    q('[data-recap-format]').textContent = etat.format;
    q('[data-recap-cadre]').textContent = etat.encadre ? etat.cadre : 'Sans cadre, affiche seule';

    q('[data-resume-1]').textContent = etat.nb + (etat.nb > 1 ? ' animaux' : ' animal');
    q('[data-resume-2]').textContent = etat.fond;
    q('[data-resume-3]').textContent = etat.format + ', ' + (etat.encadre ? etat.cadre.toLowerCase() : 'sans cadre');


    var remplis = 0;
    for (var i = 0; i < etat.nb; i++) {
      if (etat.noms[i] && (etat.photoPlusTard || etat.photos[i])) remplis++;
    }
    q('[data-resume-4]').textContent = remplis === etat.nb
      ? (etat.photoPlusTard ? 'Photo à envoyer plus tard' : 'Tout est prêt')
      : remplis + ' sur ' + etat.nb + ' complété' + (etat.nb > 1 ? 's' : '');
  }

  /* Choisit l'aperçu le plus proche de la combinaison en cours.
     Le fond prime sur le cadre : mieux vaut le bon fond dans un autre cadre
     que l'inverse. « Sans cadre » emprunte le visuel du cadre blanc. */
  function urlApercu() {
    var f = CODE_FOND[etat.fond];
    var c = etat.encadre ? CODE_CADRE[etat.cadre] : 'blanc';
    var ordre = [c, 'noir', 'blanc', 'noyer', 'bouleau'];

    for (var i = 0; i < ordre.length; i++) {
      var cle = etat.nb + '|' + f + '|' + ordre[i];
      if (APERCUS[cle]) return { url: APERCUS[cle], exact: ordre[i] === c };
    }
    /* Dernier repli : n'importe quel visuel du même nombre d'animaux */
    var prefixe = etat.nb + '|';
    for (var k in APERCUS) {
      if (k.indexOf(prefixe) === 0) return { url: APERCUS[k], exact: false };
    }
    return null;
  }

  var compteurImage = 0;
  var urlSouhaitee = null;

  function rendreImage() {
    var choix = urlApercu();
    if (!choix) return;

    var img = q('[data-stage-img]');
    var legende = q('[data-stage-legende]');
    var badge = q('[data-stage-badge]');

    /* Le visuel montre toujours un cadre : on le dit franchement. */
    if (!etat.encadre) {
      badge.textContent = 'Affiche seule';
      legende.innerHTML = 'Aperçu présenté encadré pour l\'exemple. Vous recevrez <b>l\'affiche seule</b>, roulée dans un tube.';
    } else {
      badge.textContent = 'Aperçu';
      legende.innerHTML = 'Voici le rendu du style <b>' + (window.Shopify && window.Shopify.shop ? 'Gustave' : 'Gustave') +
                          '</b>. Votre portrait sera dessiné d\'après votre photo.';
    }

    if (urlSouhaitee === choix.url) return;
    urlSouhaitee = choix.url;

    /* Jeton de requête : sans lui, deux clics rapprochés font gagner
       le visuel qui finit de charger en dernier, pas celui demandé en dernier. */
    var jeton = ++compteurImage;
    var description = 'Portrait personnalisé, ' + etat.nb + (etat.nb > 1 ? ' animaux' : ' animal') +
                      ', fond ' + etat.fond.toLowerCase() + ', ' +
                      (etat.encadre ? etat.cadre.toLowerCase() : 'sans cadre');

    img.classList.add('is-swapping');
    var tampon = new Image();
    tampon.onload = function () {
      if (jeton !== compteurImage) return;
      img.src = choix.url;
      img.alt = description;
      img.classList.remove('is-swapping');
    };
    tampon.onerror = function () {
      if (jeton !== compteurImage) return;
      img.classList.remove('is-swapping');
    };
    tampon.src = choix.url;
  }

  function rendreJauge() {
    qa('[data-dot]').forEach(function (d) {
      var n = parseInt(d.dataset.dot, 10);
      d.dataset.state = n < etat.etape ? 'done' : (n === etat.etape ? 'current' : '');
    });
    q('[data-jauge]').setAttribute('aria-valuenow', String(etat.etape));
  }

  function rendreEtapes() {
    qa('[data-etape]').forEach(function (el) {
      var n = parseInt(el.dataset.etape, 10);
      el.dataset.open = n === etat.etape ? 'true' : 'false';
      el.dataset.done = n < etat.max ? 'true' : 'false';
      if (n <= etat.max) el.removeAttribute('data-locked');
      else el.dataset.locked = 'true';
    });

    var cta = q('[data-barre-cta]');
    cta.textContent = etat.etape >= 4 ? 'Ajouter au panier' : 'Continuer';
  }

  /* Sur mobile, l'aperçu se déplace pour rester juste au-dessus de l'étape
     ouverte. Le visiteur voit donc le tableau changer sans jamais quitter
     des yeux les options qu'il manipule. En desktop il retourne dans sa
     colonne de gauche. */
  function placerScene() {
    var scene = q('.stage');
    if (!scene) return;

    if (window.matchMedia('(max-width: 900px)').matches) {
      var etape = q('[data-etape="' + etat.etape + '"]');
      if (etape && etape.previousElementSibling !== scene) {
        etape.parentNode.insertBefore(scene, etape);
      }
    } else {
      var grille = q('.tunnel__grid');
      if (grille && scene.parentNode !== grille) {
        grille.insertBefore(scene, q('.tunnel__steps'));
      }
    }
  }

  /* Après un choix visuel, on s'assure que l'aperçu est bien à l'écran.
     Ne bouge la vue que si nécessaire, pour ne pas la faire sauter à
     chaque clic quand le tableau est déjà visible. */
  function montrerApercu() {
    if (!window.matchMedia('(max-width: 900px)').matches) return;
    var cadre = q('.stage__frame');
    if (!cadre) return;

    var entete = document.querySelector('[data-entete]');
    var haut = entete ? entete.getBoundingClientRect().height : 64;
    var r = cadre.getBoundingClientRect();

    if (r.top >= haut - 2 && r.bottom <= window.innerHeight - 60) return;

    window.scrollTo({
      top: r.top + window.pageYOffset - haut - 10,
      behavior: 'smooth'
    });
  }

  function tout() {
    recaler();
    rendreNb();
    rendreFonds();
    rendreFormats();
    rendreCadres();
    rendreAnimaux();
    majModePhoto();
    rendrePrix();
    rendreRecap();
    rendreImage();
    rendreJauge();
    rendreEtapes();
    placerScene();
  }

  /* =========================================================
     NAVIGATION
     ========================================================= */
  /* Pas de défilement automatique : les étapes sont des accordéons,
     déplacer la vue sous les pieds du visiteur est désorientant. */
  function allerA(n) {
    n = Math.max(1, Math.min(4, n));
    if (n > etat.max) etat.max = n;
    etat.etape = n;
    rendreEtapes();
    rendreJauge();
    rendreRecap();
    placerScene();
  }

  /* =========================================================
     ÉVÉNEMENTS
     ========================================================= */
  racine.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-opt]');
    if (opt) {
      var type = opt.dataset.opt, val = opt.dataset.valeur;
      if (type === 'nb') {
        etat.nb = parseInt(val, 10);
        if (!etat.fondChoisi) appliquerDefaut(etat.nb);
      }
      else if (type === 'fond') { etat.fond = val; etat.fondChoisi = true; }
      else if (type === 'format') { etat.format = val; }
      else if (type === 'cadre') { etat.cadre = val; etat.encadre = true; }
      tout();
      montrerApercu();
      return;
    }

    var mode = e.target.closest('[data-photo-mode]');
    if (mode) {
      etat.photoPlusTard = mode.dataset.photoMode === 'plus-tard';
      majModePhoto();
      rendreRecap();
      cacherErreur();
      return;
    }

    var seg = e.target.closest('[data-segment]');
    if (seg) {
      if (seg.dataset.disabled === 'true') { e.preventDefault(); return; }
      etat.encadre = seg.dataset.segment === 'cadre';
      if (!etat.encadre) etat.cadre = SANS_CADRE;
      else if (etat.cadre === SANS_CADRE) etat.cadre = 'Cadre noir';
      tout();
      montrerApercu();
      return;
    }

    var suiv = e.target.closest('[data-suivant]');
    if (suiv) { allerA(parseInt(suiv.dataset.suivant, 10) + 1); return; }

    var ret = e.target.closest('[data-retour]');
    if (ret) { allerA(parseInt(ret.dataset.retour, 10) - 1); return; }

    var tete = e.target.closest('[data-toggle]');
    if (tete) {
      var bloc = tete.closest('[data-etape]');
      if (bloc.dataset.locked === 'true') return;
      allerA(parseInt(bloc.dataset.etape, 10));
      return;
    }
  });

  /* Prénoms */
  racine.addEventListener('input', function (e) {
    var nom = e.target.closest('[data-nom]');
    if (nom) { etat.noms[parseInt(nom.dataset.nom, 10)] = nom.value.trim(); rendreRecap(); cacherErreur(); }
  });

  /* Photos */
  racine.addEventListener('change', function (e) {
    var photo = e.target.closest('[data-photo]');
    if (photo) {
      var i = parseInt(photo.dataset.photo, 10);
      var f = photo.files && photo.files[0];
      var depot = photo.closest('[data-depot]');
      if (!f) { etat.photos[i] = null; depot.classList.remove('depot--ok'); rendreRecap(); return; }

      if (f.size > 19 * 1024 * 1024) {
        photo.value = '';
        etat.photos[i] = null;
        montrerErreur('Cette photo dépasse 19 Mo. Prenez une version un peu plus légère, la qualité reste largement suffisante.');
        return;
      }

      etat.photos[i] = f;
      depot.classList.add('depot--ok');
      q('[data-depot-nom]', depot).textContent = f.name;
      var icone = q('[data-depot-icone]', depot);
      icone.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m4.5 12.5 5 5 10-11"/></svg>';

      if (window.FileReader && /^image\//.test(f.type)) {
        var fr = new FileReader();
        fr.onload = function () {
          var v = document.createElement('img');
          v.className = 'depot__vignette';
          v.src = fr.result;
          v.alt = '';
          var zone = q('.depot__zone', depot);
          var ancienne = q('.depot__vignette', depot);
          if (ancienne) ancienne.remove();
          zone.appendChild(v);
        };
        fr.readAsDataURL(f);
      }
      cacherErreur();
      rendreRecap();
      return;
    }

    var ap = e.target.closest('[data-apercu-input]');
    if (ap) { etat.apercu = ap.checked; rendrePrix(); }
  });

  /* Glisser-déposer */
  racine.addEventListener('dragover', function (e) {
    var d = e.target.closest('[data-depot]');
    if (d) { e.preventDefault(); d.classList.add('depot--drag'); }
  });
  racine.addEventListener('dragleave', function (e) {
    var d = e.target.closest('[data-depot]');
    if (d) d.classList.remove('depot--drag');
  });
  racine.addEventListener('drop', function (e) {
    var d = e.target.closest('[data-depot]');
    if (!d) return;
    e.preventDefault();
    d.classList.remove('depot--drag');
    var input = q('[data-photo]', d);
    if (e.dataTransfer.files && e.dataTransfer.files.length) {
      input.files = e.dataTransfer.files;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* Erreurs */
  function montrerErreur(msg) {
    var el = q('[data-erreur]');
    el.hidden = false;
    el.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 7.5V13"/><path d="M12 16.5h.01"/></svg><span>' + msg + '</span>';
    el.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  function cacherErreur() { q('[data-erreur]').hidden = true; }

  /* =========================================================
     ENVOI
     ========================================================= */
  var form = q('[data-form]');
  var envoi = false;

  form.addEventListener('submit', function (e) {
    if (envoi) return;
    e.preventDefault();
    cacherErreur();

    /* Vérifications */
    for (var i = 0; i < etat.nb; i++) {
      if (!etat.noms[i]) {
        allerA(4);
        montrerErreur('Il manque le prénom ' + (etat.nb > 1 ? 'de l\'animal ' + (i + 1) : 'de votre animal') + '. C\'est lui qui sera écrit sur le tableau.');
        var champ = q('[data-nom="' + i + '"]');
        if (champ) champ.focus();
        return;
      }
      if (!etat.photoPlusTard && !etat.photos[i]) {
        allerA(4);
        montrerErreur('Il manque la photo ' + (etat.nb > 1 ? 'de l\'animal ' + (i + 1) : 'de votre animal') +
                      '. Vous pouvez aussi choisir « Je l\'envoie plus tard » juste au-dessus.');
        return;
      }
    }

    var v = variante();
    if (!v) { montrerErreur('Cette combinaison n\'est plus disponible. Changez de fond ou de format et réessayez.'); return; }

    var bouton = q('[data-envoyer]');
    bouton.disabled = true;
    bouton.innerHTML = 'On prépare tout ça…';
    envoi = true;

    function partir() { form.submit(); }

    /* Les extras (aperçu, mug offert) sont des lignes à part : on les ajoute
       avant d'envoyer le portrait, qui lui part en multipart avec les photos. */
    var extras = [];

    if (etat.apercu && APERCU_ID) {
      extras.push({ id: parseInt(APERCU_ID, 10), quantity: 1 });
    }

    if (MUG_ID) {
      var prenoms = etat.noms.slice(0, etat.nb).filter(Boolean).join(', ');
      extras.push({
        id: parseInt(MUG_ID, 10),
        quantity: 1,
        properties: {
          'Cadeau': 'Offert avec votre portrait',
          'Prénom': prenoms || 'À préciser',
          'Illustration': 'Identique à celle du tableau'
        }
      });
    }

    if (extras.length) {
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: extras })
      }).then(partir).catch(partir);
    } else {
      partir();
    }
  });

  /* =========================================================
     DÉPART
     ========================================================= */
  etat.fond = fonds()[0];
  etat.format = formats()[0];
  appliquerDefaut(etat.nb);
  tout();

  window.addEventListener('resize', placerScene, { passive: true });
})();
